import React from 'react';
import Amplify, { Auth } from 'aws-amplify';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { StoreContext } from 'redux-react-hook';
import App from './App';
import './App.scss';
import * as serviceWorker from './serviceWorker';
import { makeStore } from './store';
import { AMPLIFY_CONF, API_GATEWAY, API_GATEWAY_MVI } from './utils/constants';
import { localStorageGet, localStorageSet } from './utils/storage';

const {store, persistor} = makeStore();

Amplify.configure({
    Auth: {
      identityPoolId: AMPLIFY_CONF.IDENTITY_POOL_ID,
      mandatorySignIn: AMPLIFY_CONF.MANDATORY_SIGN_IN,
      region: AMPLIFY_CONF.REGION,
      userPoolId: AMPLIFY_CONF.USER_POOL_ID,
      userPoolWebClientId: AMPLIFY_CONF.USER_POOL_WEB_CLIENT_ID,
      oauth: {
        domain: AMPLIFY_CONF.OAUTH.DOMAIN,
        redirectSignIn: AMPLIFY_CONF.OAUTH.REDIRECT_SIGNIN,
        redirectSignOut: AMPLIFY_CONF.OAUTH.REDIRECT_SIGNOUT,
        responseType: AMPLIFY_CONF.OAUTH.RESPONSE_TYPE,
        scope: AMPLIFY_CONF.OAUTH.SCOPE
      }
    },
    Storage: {
      identityPoolId: AMPLIFY_CONF.IDENTITY_POOL_ID,
      region: AMPLIFY_CONF.REGION,
      bucket: AMPLIFY_CONF.BUCKET_S3
    },
    API: {
      endpoints: [
        {
          name: API_GATEWAY.NAME,
          endpoint: API_GATEWAY.URL,
          region: API_GATEWAY.REGION,
          custom_header: async () => {
            const user: any = await Auth.currentSession();
            const { idToken = {} } = user;
            const token = idToken.jwtToken
            if (localStorageGet('tkn') !== token)
              localStorageSet('tkn', token);
            return token ? ({
              user: token
            }) : ({})
          }
        },
        {
          name: API_GATEWAY_MVI.NAME,
          endpoint: API_GATEWAY_MVI.URL,
          region: API_GATEWAY_MVI.REGION,
          custom_header: async () => {
            const user: any = await Auth.currentSession();
            const { idToken = {} } = user;
            const token = idToken.jwtToken
            if (localStorageGet('tkn') !== token)
              localStorageSet('tkn', token);
            return ({})
          }
        }
      ]
    }
  });

ReactDOM.render(
    <StoreContext.Provider value={store}>
        <PersistGate persistor={persistor}>
            <App />
        </PersistGate>  
    </StoreContext.Provider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
